<nav class="app-sidebar modern-sidebar">

  <section class="sidebar-header">
    <a [routerLink]="['/']" class="brand">
      <img height="45" width="184" src="assets/images/logo_talkmaestro.png" alt="TalkMaestro">
    </a>
  </section>

  <section class="sidebar-content">
    <my-app-sidenav-menu></my-app-sidenav-menu>
  </section>

  <section class="sidebar-footer">
    <ul class="nav">
      <li>
        <span class="version-system">
          <span class="version-label">Versão:</span>
          <span class="version-number">{{AppConfig.version}}</span>
        </span>
      </li>
    </ul>
  </section>
</nav>